const ARTICLES =[
    {
        title:"Polymeric Materials for Articulating Motion Preservation Devices",
        image:"img/science0.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"In a first, physicists accelerate atoms in the Large Hadron Collider",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }, {
        title:"How the Parker probe was built to survive close encounters with the sun",
        image:"img/science1.jpg",
        video:"https://www.youtube.com/embed/WvXYQ1QSFV4",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"People are bad at spotting fake news. Can computer programs do better?",
        image:"img/science2.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Trauma",
        section:"Product Information",
        audience:"Physics"
    },  {
        title:"What does Mars’ lake mean for the search for life on the Red Planet?",
        image:"img/science3.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Spine",
        section:"Abstract summary",
        audience:"Chemists"
    },  {
        title:"This tick may play a part in gumming up your arteries",
        image:"img/science4.jpg",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Dental",
        section:"Case Study",
        audience:"Chemists"
    },  {
        title:"A new quasiparticle lurks in semiconductors",
        image:"img/science5.jpg",
        video:"https://www.youtube.com/embed/KFS4oiVDeBI",
        content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        speciality:"Ortho",
        section:"Abstract summary",
        audience:"Physics"
    }

];

export default ARTICLES;


// WEBPACK FOOTER //
// ./src/data/articles.js